export default {
    common: require("./common.json"),
    hero: require("./hero.json"),
    gallery: require("./gallery.json"),
};
